import { useEffect, useRef } from "react"
import wx from "weixin-js-sdk"
interface ShareType {
  title: string
  path: string
  type: "share" | "back" | "destroy"
  imageUrl?: string
  basePath?: string // 分享的基础路径
  shareQuery?: string // 分享需要的参数
  selfQuery?: string // 维护自身的参数
}

interface SendMessageProps {
  sendMessage: (data: ShareType) => void
}
const REACT_APP_APPLE = process.env.REACT_APP_APPLE
const useSendCurrentPagePath = () => {
  const sendRef = useRef({ sendMessage: () => {} } as SendMessageProps)
  useEffect(() => {
    const currentUrl = window.location.href;
    // 获取主机名和协议
    const currentUrls = new URL(currentUrl);
    sendRef.current.sendMessage = ({ title, type, path, imageUrl, basePath, shareQuery = "", selfQuery = "" }: ShareType) => {
      wx.miniProgram.postMessage({
        type: 'currentPagePath',
        data: {
          title,
          imageUrl,
          basePath,
          path: `${REACT_APP_APPLE}${path || currentUrls.pathname}`,
          // path: `http://192.168.16.79:3000${path || currentUrls.pathname}`,
          type,
          shareQuery,
          selfQuery
        }
      })
    }
  }, [])
  //
  return { sendMessage:sendRef.current.sendMessage }
}
export default useSendCurrentPagePath